<template>
  <div :data-pc-key="config.key" :class="getClass()" :style="getStyle()" draggable="true" :title="config.desc || config.text">
    <drop-position :text="getShowText()" :dropMode="dropMode" @remove="triggerRemove" @clone="clone"></drop-position>
    <component v-for="c in children" :key="c.key" :is="c.configComponent" :endpoint="endpoint" :group="group" :config="c" ref="childComponents" @remove="removeChild"></component>
  </div>
</template>

<script>
import mixin from './mixin.js'

export default {
  name: 'common-component',
  mixins: [mixin]
}
</script>
